import PRODUCT_TYPES from '../lib/product-types.json'

const ADDONS = PRODUCT_TYPES.productTypes.filter(
  (productType) => !PRODUCT_TYPES.parentProductTypes.includes(productType),
)

const TYPES = PRODUCT_TYPES.parentProductTypes

export { ADDONS, TYPES }
